import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { popUpMenuChange, 
        selectedCardsGroupsChange, 
        setCycleData,
        deleteCards,
        editCards, 
        editFeaturesGroup, 
        editFigures,
        popUpMessageChange } from '../../../actions/index'

import Icon from '@mdi/react';
import { mdiSetMerge } from '@mdi/js';

import { _ } from '../../../functions/translator'

import { postData } from '../../../functions/postData.js';
import { reloadCardsGroupsFeatures } from '../../../functions/map/reloadCardsGroups';
import { showMessage } from '../../../functions/popUpMessage.js';

class MergeButton extends React.Component{
          
    getMergeableTotal = () => {
        let text = ''
        if (this.props.mergeableCardsGroups.cardsGroupIds.length > 1) {
            text += '(' + this.props.mergeableCardsGroups.cardsGroupIds.length + ' '+ _('disponibles') + ')'
        }
        return text
    }

    handleClick = async () => {
        this.props.popUpMenuChange({
            show: false,
            close: false,
            opacity: this.props.popUpMenu.opacity ? 0 : 1,
            cyclesButton: false
        })
        this.props.selectedCardsGroupsChange([])
        const message = _("Agrupando Protocolos") + '...';
        showMessage(this.props, message, { loading: true });
        let urlPost = {
            project_id: window.project_id,
            cards_group_ids: this.props.mergeableCardsGroups.cardsGroupIds,
            figure_ids: this.props.mergeableCardsGroups.figureIds
        }
        let response = await postData('/web-api/merge-cards-groups', urlPost)
        this.handleResponse(response)
    }

    handleResponse = (response) => {
        if(response) {
            this.props.deleteCards(this.props.mergeableCardsGroups.cardsGroupIds)
            for (const cardsGroupId of this.props.mergeableCardsGroups.cardsGroupIds) {
                delete this.props.projectData.cards_groups[cardsGroupId]
            }
            reloadCardsGroupsFeatures(this.props, response.new_cards_group_ids)
            showMessage(this.props, '¡'+ _('Se han agrupado los protocolos correctamente')+ '!');
        } else {
            showMessage(this.props, _('No se pudieron agrupar los protocolos'));

        }
    }

    render(){   
        
        let mergeableTotal = this.getMergeableTotal()
        let textClass = this.props.mergeableCardsGroups.cardsGroupIds.length > 1 ? 'text-wrap-button' : '';
        return (
            <div>
                <div 
                    className={`popup-menu-button card-color 
                        ${this.props.mergeableCardsGroups.cardsGroupIds.length < 2 && 'visible-disabled'}`
                    } 
                    ref={ref => this.button = ref} 
                    onClick={this.handleClick}>
                    <div className='d-inline-flex'>
                        <Icon path={ mdiSetMerge } size='30px' color='white' style={{margin: 10}}/>
                        <p className={`d-flex flex-row ${mergeableTotal !== '' && 'my-1 align-items-center'}`}>
                            <div className='d-flex flex-column'>
                                { _('Agrupar Elementos') }
                                <span>{ mergeableTotal }</span>
                            </div>
                            <span className={textClass + ' ml-1'}>(Ctrl + A)</span>
                        </p>
                    </div>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        popUpMenu : state.popUpMenu,
        projectData : state.projectData,
        selectedCardsGroups : state.selectedCardsGroups
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({
        popUpMenuChange : popUpMenuChange,
        popUpMessageChange : popUpMessageChange,
        selectedCardsGroupsChange : selectedCardsGroupsChange,
        deleteCards : deleteCards,
        setCycleData : setCycleData,
        editCards : editCards,
        editFeaturesGroup : editFeaturesGroup,
        editFigures : editFigures
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(MergeButton)